import { render } from "./StylesTopic.vue?vue&type=template&id=210ea73b"
import script from "./StylesTopic.vue?vue&type=script&lang=js"
export * from "./StylesTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__